/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import SifCountry from 'linced-admin/enums/sif-country';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ZonesRoute extends Route {
  queryParams = {
    country: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    if (
      isEmpty(params.country) ||
      isEmpty(SifCountry.values.find((c) => c.value === params.country))
    ) {
      params.country = SifCountry.AUSTRALIA;
    }
    return hash({
      zones: this.store.findAll(`sif/${params.country}/zone`),
    });
  }
}
